import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from "components/core/Typography";
import { Link } from "components/core/Link";
import { Image } from "@sparefoot/react-commons";

import './RelatedContentCard.scss';

const RelatedContentCard = ({ item: { url, image, category, content, date } }) => (
		<Link
			href={url}
			target="_blank"
			rel="noreferrer noopener"
		>
			<div className="related-card">
				<div className="related-card__image-container">
					<Image
						src={image}
						alt={content}
						className="related-card__image"
					/>
				</div>
				<div className="related-card__content">
					<Paragraph className="category">{category}</Paragraph>
					<Paragraph>{content}</Paragraph>
					<Paragraph className="date">{date}</Paragraph>
				</div>
			</div>
		</Link>
	);


RelatedContentCard.propTypes = {
	item: PropTypes.shape({
		category: PropTypes.string.isRequired,
		content: PropTypes.string,
		date: PropTypes.string,
		url: PropTypes.string.isRequired,
		image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	}).isRequired,
};

export default RelatedContentCard;
